import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { WorkspaceService } from 'src/app/v2-node-api/services/workspace.service';
import {API_URLS} from 'src/environments/env-routes';
import { User } from 'src/shared/models/user.class';
import { APIHelper } from 'src/shared/services/api-helper/api-helper.service';
import { BoardService } from 'src/shared/services/board.service';

@Component({
  selector: 'dialog-permissions-kanban',
  templateUrl: './dialog-permissions-kanban.component.html',
  styleUrls: ['./dialog-permissions-kanban.component.scss']
})
export class DialogPermissionsKanbanComponent implements OnInit {
  public privacy: string;
  public listUsersAndGroups: any[];
  public loading: boolean;
  private loadingUsers: boolean;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<DialogPermissionsKanbanComponent>,
    private kanbanService: BoardService,
    private api: APIHelper) { }

  ngOnInit(): void {
    this.privacy = this.data.actualNode.privacy || 'public';
    this.listUsersAndGroups =  [...this.data.actualNode.listPeopleAuthorized] || [];
    this.loading = false;

    if(this.listUsersAndGroups.length) {
      this.loadingUsers = true;

      

      const res = this.listUsersAndGroups.map(async (user) => {
        let request; 

        if (user.uType === 'cm:person') {
          request = this.api.requestApi({ action: API_URLS.people.get.replace(':userId', user.id) });
        } else {
          request = this.api.requestApi({ action: API_URLS.groups.getOne.replace(':groupId', user.id) });
        }

        return request.then((u) => ({...u, uType: user.uType, id: user.id}))
      });

      Promise.all(res).then((res) => {
        this.listUsersAndGroups = res.map(u => ({
          id: u.id,
          displayName: u.uType === 'cm:person' ? `${u.firstName} ${u.lastName}` : u.displayName,
          uType: u.uType
        }));
      }).finally(() => this.loadingUsers = false);
    }
  }

  onValidate() {
    this.loading = true;
    this.kanbanService.updateKanban(this.data.actualNode._id, this.privacy, this.listUsersAndGroups, this.data.actualNode
    )
    .toPromise()
    .then((res) => this.dialogRef.close(res))
    .finally(() => this.loading = false);
  }

  onCancel() {
    this.dialogRef.close(false);
  }
}
